window.theme = window.theme || {};

window.theme.whenVisible = function whenVisible(element, callback, options = {}) {
  if (!element || typeof callback !== 'function') return null;

  if (element.dataset.visibilityInitialized === 'true') {
    return null;
  }

  const run = () => {
    if (element.dataset.visibilityInitialized === 'true') return;
    element.dataset.visibilityInitialized = 'true';
    callback();
  };

  if (!('IntersectionObserver' in window)) {
    run();
    return null;
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting || entry.intersectionRatio > 0)) {
      return;
    }

    observer.disconnect();
    run();
  }, {
    rootMargin: options.rootMargin || '200px 0px',
    threshold: options.threshold ?? 0.01,
  });

  observer.observe(element);
  return observer;
};
